// @ts-nocheck

import { Target } from '../client';
import { LocalesBasename } from '../types/common';

const lang = ['fr', 'en', 'de', 'it', 'es', 'pt'];

const config = {
  keepalive: {
    waitInterval: 900000,
    countInterval: 0,
  },
  paging: {
    size: 20,
  },
  analytics: {
    trackingId: 'UA-16886136-1',
  },
  facebook: {
    appId: 396068630467067,
  },
  basket: {
    version: 2,
    defaultStake: 5,
  },
  socketDefaultConfig: Target.__SOCKETS__,
  wapiEndpoint: Target.__API_HOSTS__,
  linkHost: Target.__LINK_HOST__,
  webHost: lang.reduce((prev, curr) => {
    prev[curr] = Target.__WEBHOSTS__[curr];
    return prev;
  }, {}),
  bracketRedirectUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/challenges/bracket_redirect.php`;
    return prev;
  }, {}),
  keepaliveUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/keepalive.php`;
    return prev;
  }, {}),
  streamingUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/get_stream.php`;
    return prev;
  }, {}),
  basketUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/validate_betslip.php`;
    return prev;
  }, {}),
  cashoutUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/validate_cashout.php`;
    return prev;
  }, {}),
  historyUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/get_bets.php`;
    return prev;
  }, {}),
  connectUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/account/login.php?betting=1`;
    return prev;
  }, {}),
  connectFromBasketUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/account/login.php?betting=1&cart=1`;
    return prev;
  }, {}),
  standaloneLoginUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/api/authenticate.php`;
    return prev;
  }, {}),
  standaloneLogoutUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/api/logout.php`;
    return prev;
  }, {}),
  validateEventsUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/api/events.php`;
    return prev;
  }, {}),
  validateCGUUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/api/terms.php`;
    return prev;
  }, {}),
  // ${store} and ${id} arguments should be substitute
  updateBundleUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/poker/redirect.php?service=app_store&os=ios&store=\${store}&id=\${id}`;
    return prev;
  }, {}),
  iframeDECRM: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/display-betting-promotions.php`;
    return prev;
  }, {}),
  basketGridUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__WEBHOSTS__[curr]}/betting/grids/validate_grid.php`;
    return prev;
  }, {}),
  sharingGridUrl: lang.reduce((prev, curr) => {
    switch (curr) {
      case 'en':
        prev[curr] = `${Target.__WEBHOSTS__[curr]}/sports-betting/grilles/share`;
        break;
      case 'de':
        prev[curr] = `${Target.__WEBHOSTS__[curr]}/sportwetten/grilles/share`;
        break;
      case 'it':
        prev[curr] = `${Target.__WEBHOSTS__[curr]}/scommesse-sportive/grilles/share`;
        break;
      case 'es':
        prev[curr] = `${Target.__WEBHOSTS__[curr]}/apuestas-deportivas/grilles/share`;
        break;
      case 'pt':
        prev[curr] = `${Target.__WEBHOSTS__[curr]}/apostas-desportivas/grilles/share`;
        break;
      case 'fr':
      default:
        prev[curr] = `${Target.__WEBHOSTS__[curr]}/paris-sportifs/grilles/share`;
    }
    return prev;
  }, {}),
  userDataUrl: lang.reduce((prev, curr) => {
    prev[curr] = `${Target.__API_HOSTS__[curr]}/operator/userdata`;
    return prev;
  }, {}),
  shareBetslipShareUrl: lang.reduce((prev, curr) => {
    prev[curr] = {
      // host without https:// prefix
      host: Target.__WEBHOSTS__[curr].replace('https://', '').replace('http://', ''),
      path: `/${LocalesBasename[curr]}`,
    };

    return prev;
  }, {}),
};

export default config;
